
import NetMsgDataToBuffer from "../../../../framework/net/net_msgdata_to_buffer";
import { Hallx } from "./proto_club_hall_notify";


export class NetMsgDataMapClubHall extends NetMsgDataToBuffer{

    

    static readonly Ping: any[] = [ "Hallx.IdlePingReq",Hallx.IdlePingReq,
                                    "Hallx.IdlePingRsp",Hallx.IdlePingRsp,3];

    static readonly Auth: any[] = [ "Hallx.AuthReq",Hallx.AuthReq,
                                    "Hallx.AuthRsp",Hallx.AuthRsp,3];

    static readonly RoomInfoNotify: any[] = [ null,null,"Hallx.RoomInfoNotify",Hallx.RoomInfoNotify,3];

    static readonly BatchRoomInfosNotify: any[] = [ null,null,"Hallx.BatchRoomInfosNotify",Hallx.BatchRoomInfosNotify,3];

    static readonly OneRoundGameResultNotify: any[] = [ null,null,"Hallx.OneRoundGameResultNotify",Hallx.OneRoundGameResultNotify,3];

    static readonly RoomClosedNotify: any[] = [ null,null,"Hallx.RoomClosedNotify",Hallx.RoomClosedNotify,3];

    static readonly Quit : any[] = ["Hallx.Quit",Hallx.Quit,null,null,3];
} 